import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';

export class DateFormats {
  public static UTC = { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'yyyy-MM-dd', timezone: 'UTC' } };
  public static UTCMediumDate = {
    provide: DATE_PIPE_DEFAULT_OPTIONS,
    useValue: { dateFormat: 'mediumDate', timezone: 'UTC' }
  };
  public static Default = { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'MM/dd/yyyy' } };
}
